import {
    GET_PURCHASE_ORDER_LIST_PROGRESS, GET_PURCHASE_ORDER_LIST_SUCCESS, GET_PURCHASE_ORDER_LIST_FAILURE,
    ADD_PURCHASE_ORDER_PROGRESS, ADD_PURCHASE_ORDER_SUCCESS, ADD_PURCHASE_ORDER_FAILURE,
    EDIT_DELETE_PURCHASE_ORDER_PROGRESS, EDIT_DELETE_PURCHASE_ORDER_SUCCESS, EDIT_DELETE_PURCHASE_ORDER_FAILURE,
   
    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    purchaseOrder: [],
    lastEntryNo:null,
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const purchase_order_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PURCHASE_ORDER_LIST_SUCCESS:
            return { ...state, purchaseOrder: action.purchaseOrder, lastEntryNo: action.purchaseOrder[0].purchaseNo, loading: false };
        case GET_PURCHASE_ORDER_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_PURCHASE_ORDER_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_PURCHASE_ORDER_PROGRESS:
            return { ...state, loading: true };
        case ADD_PURCHASE_ORDER_SUCCESS:
            return { ...state, purchaseOrder: [...state.purchaseOrder, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_PURCHASE_ORDER_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
        case EDIT_DELETE_PURCHASE_ORDER_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_PURCHASE_ORDER_SUCCESS:
            return {
                ...state,
                purchaseOrder: state.purchaseOrder.map((purchaseOrder) =>
                purchaseOrder.id === action.payload.id ? action.payload : purchaseOrder
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_PURCHASE_ORDER_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
     
        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default purchase_order_reducer;